"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Option_component_exports = {};
__export(Option_component_exports, {
  Option: () => Option
});
module.exports = __toCommonJS(Option_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_react2 = require("@floating-ui/react");
var import_Select = require("../Select.context");
var import_icominds_lib = require("@greatmindsorg/icominds-lib");
var import_baseTheme = __toESM(require("../../../../themes/baseTheme"));
var _templateObject, _templateObject2;
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var textStyle = (0, import_styled_components.css)(["font-size:", ";font-family:", ";"], import_baseTheme.default.typography.sizes.large, import_baseTheme.default.typography.fonts.teacherExp);
var AsLink = function AsLink2(_ref) {
  var children = _ref.children, url = _ref.url;
  return /* @__PURE__ */ import_react.default.createElement(_StyledA, {
    href: url,
    $_css2: [{
      "width": "100%",
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 0 / var(--tw-text-opacity))",
      "textDecorationLine": "none"
    }]
  }, children);
};
var AsPresentational = function AsPresentational2(_ref2) {
  var children = _ref2.children;
  return /* @__PURE__ */ import_react.default.createElement("div", null, children);
};
var Option = function Option2(_ref3) {
  var label = _ref3.label, children = _ref3.children, onClick = _ref3.onClick, customStyle = _ref3.customStyle, role = _ref3.role, url = _ref3.url;
  var _useContext = (0, import_react.useContext)(import_Select.SelectContext), activeIndex = _useContext.activeIndex, selectedIndex = _useContext.selectedIndex, getItemProps = _useContext.getItemProps, handleSelect = _useContext.handleSelect, setLabel = _useContext.setLabel, moreThanOneChildren = _useContext.moreThanOneChildren;
  var _useListItem = (0, import_react2.useListItem)({
    label
  }), ref = _useListItem.ref, index = _useListItem.index;
  var isActive = activeIndex === index;
  var isSelected = selectedIndex === index;
  var content = children !== null && children !== void 0 ? children : label;
  var handleOnClick = onClick !== null && onClick !== void 0 ? onClick : function() {
    return void 0;
  };
  var selectedStyle = isSelected ? {
    "fontWeight": "700"
  } : {
    "fontWeight": "300"
  };
  var handleClick = function handleClick2(i, child) {
    handleOnClick();
    handleSelect(i, child);
    setLabel(label);
  };
  (0, import_react.useEffect)(function() {
    if (!moreThanOneChildren)
      setLabel(label);
    if (isSelected)
      setLabel(label);
  }, [isSelected]);
  var buttonStyle = _objectSpread(_objectSpread({}, textStyle), {}, {
    overflowWrap: "anywhere"
  });
  var isflyoutMenu = role === "flyoutMenu";
  var roleImplemented = isflyoutMenu ? "menuitem" : "presentation";
  var Container = isflyoutMenu ? AsLink : AsPresentational;
  return /* @__PURE__ */ import_react.default.createElement(_StyledButton, _extends({
    type: "button",
    ref,
    role: roleImplemented,
    tabIndex: isActive ? 0 : -1,
    className: "select__option"
  }, getItemProps({
    onClick: function onClick2() {
      handleClick(index, content);
    }
  }), {
    $_css3: [{
      "display": "flex",
      "width": "100%",
      "alignItems": "center",
      "justifyContent": "space-between",
      "borderWidth": "1px",
      "borderLeftWidth": "0px",
      "borderRightWidth": "0px",
      "borderTopWidth": "0px",
      "borderStyle": "solid",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(112 108 92 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "padding": "1rem",
      "paddingRight": "2rem",
      "&:last-child": {
        "borderWidth": "0px"
      },
      "&:hover": {
        "cursor": "pointer",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(234 237 225 / var(--tw-bg-opacity))"
      },
      "&:focus": {
        "zIndex": "10",
        "outlineColor": "#706C5C"
      }
    }, buttonStyle, selectedStyle, customStyle]
  }), /* @__PURE__ */ import_react.default.createElement(Container, {
    styles: {
      "display": "flex",
      "flexGrow": "1",
      "paddingRight": "1rem",
      "textAlign": "left",
      "fontSize": "1rem",
      "lineHeight": "1.5rem"
    },
    url
  }, content), isSelected && /* @__PURE__ */ import_react.default.createElement(_StyledDiv, null, /* @__PURE__ */ import_react.default.createElement(import_icominds_lib.Check, {
    color: "#407177",
    title: "Selected",
    iconSize: "xl"
  })));
};
var _StyledA = (0, import_styled_components.default)("a")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css2;
});
var _StyledButton = (0, import_styled_components.default)("button")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css3;
});
var _StyledDiv = (0, import_styled_components.default)("div").withConfig({
  displayName: "Optioncomponent___StyledDiv",
  componentId: "sc-119cs8b-0"
})({
  "display": "flex",
  "flex": "none"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Option
});
//# sourceMappingURL=Option.component.js.map